import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['option', 'apply', 'bsSelect', 'filter'];
  categoryName = 'category[]';

  initialize() {
    const params = new URLSearchParams(location.search);
    const categories = params.getAll(this.categoryName);

    if (categories.length) {
      // to make sure the combobox already rendered
      setTimeout(() => {
        this.toggleAdaptiveFilters(categories);
        this.toggleAdaptiveOptions(categories);
      }, 300);
    }
  }

  select(e) {
    const {name} = e.target;
    const values = [];

    this.optionTargets.forEach(el => {
      const {name, checked, value} = el;
      if (checked && (name === this.categoryName)) {
        values.push(value);
      }
    });

    if (name === this.categoryName) {
      this.toggleAdaptiveFilters(values);
      this.toggleAdaptiveOptions(values);
    }

    this.updateSearchCount();
  }

  bsSelectChange(e) {
    const {name} = e.target;
    const values = [];

    this.bsSelectTargets.forEach(select => {
      [...select.options]
        .filter(opt => opt.selected)
        .forEach(opt => {
          values.push(opt.value);
        })
    });

    if (name === this.categoryName) {
      this.toggleAdaptiveFilters(values);
      this.toggleAdaptiveOptions(values);
    }

    this.updateSearchCount();
  }

  searchString() {
    const params = new URLSearchParams();

    this.bsSelectTargets.forEach(select => {
      [...select.options]
        .filter(opt => opt.selected)
        .forEach(opt => {
          params.append(select.name, opt.value);
        })
    });

    this.optionTargets.forEach(el => {
      const {name, checked, value} = el;
      if (checked) {
        params.append(name, value);
      }
    });

    const search = new URLSearchParams(location.search).get('search');
    if (search) {
      params.append('search', search);
    }

    return params.toString();
  }

  updateSearchCount() {
    Rails.ajax({
      url: `${window.location.pathname}.json?${this.searchString()}`,
      type: 'get',
      success: (data) => {
        this.updateShow(data.total)
      }
    });
  }

  updateShow(count) {
    this.applyTarget.innerText = this.applyTarget
      .innerText
      .replace(/\d+/, count);
  }

  intersect(a, b) {
    return a.filter(x => b.includes(x));
  }

  toggleAdaptiveFilters(value) {
    const hidden = 'd-none';

    if (value?.length) {
      this.filterTargets.forEach(f => {
        const related = JSON.parse(f.dataset.related);

        if (!related.length || this.intersect(related, value).length) {
          f.classList.remove(hidden);
        } else {
          // turn off all checkboxes
          [...f.getElementsByTagName('input')].forEach(checkbox => checkbox.checked = false);

          // clear all combo-boxes
          [...f.getElementsByTagName('select')].forEach(select => {
            [...select.getElementsByTagName('option')].forEach(option => option.selected = false);

            $(select).selectpicker('deselectAll');
            $(select).selectpicker('refresh');
          });

          f.classList.add(hidden);
        }
      });
    } else {
      this.filterTargets.forEach(f => f.classList.remove(hidden));
    }
  }

  clearSearch(e) {
    e.preventDefault();
    e.stopPropagation();

    let searchString = new URLSearchParams(location.search);

    ['search', 'Search', 'page', 'limit'].forEach(param => {
      searchString.delete(param);
    });

    location.search = searchString.toString();
  }

  toggleAdaptiveOptions(value) {
    const targetName = 'vendor[]';
    const hidden = 'd-none';

    // by options
    const options = this.optionTargets.filter(f => f.name === targetName) || [];
    options.forEach(el => {
      const related = JSON.parse(el.dataset.related);
      if (!value.length || this.intersect(related, value).length) {
        el.classList.remove(hidden);
      } else {
        el.checked = false;
        el.classList.add(hidden);
      }
    });

    // by select
    const selects = this.bsSelectTargets.filter(f => f.name === targetName) || [];
    selects.forEach(select => {

      [...select.getElementsByTagName('option')].forEach(opt => {
        const related = JSON.parse(opt.dataset.related);
        if (!value.length || this.intersect(related, value).length) {
          opt.removeAttribute('hidden');
        } else {
          opt.selected = false;
          opt.setAttribute('hidden', '');
        }
      });

      // at leas one item in the list
      const enable = [...select.getElementsByTagName('option')].find(opt => !opt.hasAttribute('hidden'));
      if (enable) {
        select.removeAttribute('disabled');
      } else {
        select.setAttribute('disabled', true);
      }

      $(select).selectpicker('refresh');
    });
  }
}
